/* eslint-disable @typescript-eslint/naming-convention */
import { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import type { OfertaTrabajo, Post } from '@/interfaces/strapi';
import { ROUTES } from '@/constants';
import CTNIcon from '@ctn/ui/components/ctn-icon/icon';
import { JobOfferFormRequest } from '../JobOfferFormRequest';

type JobOfferProps = {
	readonly className?: string;
	readonly item: OfertaTrabajo;
};

const classNameComponent = 'c-cnm-job-offer-detail';

export const JobOfferDetail = ({ className, item }: JobOfferProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const {
		ref,
		titulo,
		funciones,
		descripcion,
		lugar,
		duracionContrato,
		horario,
		incorporacion,
		requisitos_form,
		requisitos_exp,
		requisitos_otros,
	} = item;

	return (
		<section className={wrapperClassName}>
			<Link to={ROUTES.SERVICIOS_PORTAL_EMPLEO} className={`${classNameComponent}__back`}>
				<CTNIcon icon="arrowLeft" size="size-16" />
				<span>Atrás</span>
			</Link>
			<div className={`${classNameComponent}__content`}>
				<h3 className={`${classNameComponent}__title`}>{titulo}</h3>
				<div className={`${classNameComponent}__grid`}>
					<div className={`${classNameComponent}__contentInfo`}>
						{ref && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Ref.:</span>
								<p>{ref}</p>
							</div>
						)}

						{descripcion && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Descripción del puesto:</span>
								<p>{descripcion}</p>
							</div>
						)}

						{funciones && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Funciones:</span>
								<p>{funciones}</p>
							</div>
						)}

						{lugar && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Lugar de trabajo:</span>
								<p>{lugar}</p>
							</div>
						)}

						{duracionContrato && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Duración / contrato:</span>
								<p>{duracionContrato}</p>
							</div>
						)}

						{horario && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Horario:</span>
								<p>{horario}</p>
							</div>
						)}

						{incorporacion && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Incorporación:</span>
								<p>{incorporacion}</p>
							</div>
						)}

						{requisitos_form && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Requisitos formación:</span>
								<p>{requisitos_form}</p>
							</div>
						)}

						{requisitos_exp && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Requisitos experiencia:</span>
								<p>{requisitos_exp}</p>
							</div>
						)}

						{requisitos_otros && (
							<div className={`${classNameComponent}__contentInfo-row`}>
								<span>Otros Requisitos:</span>
								<p>{requisitos_otros}</p>
							</div>
						)}
					</div>
					<div className={`${classNameComponent}__form`}>
						<JobOfferFormRequest />
					</div>
				</div>
			</div>
		</section>
	);
};
